import React from "react";
import Company from "./Company";
const Experience = (props) => {
  console.log("propss", props);
  const { work } = props;
  return (
    <>
      <h2 className="heading">Experience</h2>
      {/* <Company />; */}
      {work.map((value, index) => {
        return <Company {...value} />;
      })}
    </>
  );
};

export default Experience;
